/*
 * @file cn.js
 * @author liushengxgi
 * @date 2020-09-03 10:52:17
 * ----
 * @last Modified by liushengxgi
 * @last Modified time 2020-09-03 11:00:49
 */

export default {
    publisherSite: {
        detail: '详情',
        operator: '操作人',
        operate: '操作',
        reset: '重置',
        submit: '提交',
        search: '查询',
        total: '共',
        publisherSite: 'Publisher Site',
        mediaGroup: '媒体组',
        whitelistCompany: '加白公司',
        whitelistAccount: '加白账户',
        whitelistCampaign: '加白计划',
        addWhitelist: '添加白名单',
        addWhitelistRule: '添加白名单规则',
        resetBtn: '重置',
        atLeastOneDimension: '以下三个维度至少填写一项',
        noticeDesc: '说明：加白公司、加白账户、加白计划为"或"的关系。',
        noticeItem1: '选择"加白公司A" → 公司A下的所有账户和计划自动白名单',
        noticeItem2: '选择"加白账户B" → 账户B下的所有计划自动白名单',
        noticeItem3: '选择"加白计划C" → 仅计划C白名单',
        noticeItem4: '三者可同时选择，满足任意条件即生效。',
        mediaGroupPlaceholder2: '选填，方便后续查询',
        companyInputPlaceholder2: '批量输入公司名称，请以";;"区分.',
        accountInputPlaceholder2: '批量输入请账户id，以";;"区分.',
        campaignInputPlaceholder2: '批量输入campaign ID请以";;"区分.',
        editRule: '编辑规则',
        viewDetail: '查看详情',
        deleteRule: '删除规则',
        download: '下载',
        searchSite: '搜索 Publisher Site',
        searchMediaGroup: '搜索媒体组',
        inputSite: '输入site',
        inputMediaGroup: '输入规则名称',
        tipTitle: '注意:',
        tipContent1: '"加白公司"、"加白账户"、"加白计划"三列是"或"的关系，不是"且"的关系。',
        tipContent2: '示例：',
        tipContent3: '• 如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"',
        tipContent4: '则说明：公司A下的所有账户和计划 + 账户B下的所有计划，都可以上单到该站点。',
        tipContent41: '而不是：必须同时属于公司A且属于账户B才能上单。',
        tipContent5: '添加site过滤按照精准匹配原则，如有"weather.com"和"www.weather.com"需要匹配，请同时输入"weather.com"和"www.weather.com"。',
        tipText: '注意："加白公司"、"加白账户"、"加白计划"三列是"或"的关系，不是"且"的关系。示例：如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"，则说明：公司A下的所有账户和计划 + 账户B下的所有计划，都可以上单到该站点。而不是：必须同时属于公司A且属于账户B才能上单。',
        deleteConfirmText: '点击删除规则，意味着该行加白规则去除。确认删除吗？',
        deleteItemConfirmText: '确认删除该加白项吗？',
        deleteSuccess: '删除成功',
        siteInputPlaceholder: '请输入完整域名，域名只支持进行精准匹配。批量输入时请以“;;"区分，如“baidu.com;;www.baidu.com”',
        siteTip: 'Publisher Site仅支持精准匹配，但同时会命中"www"前缀的站点。例如输入"baidu.com"，会同时命中"baidu.com"和"www.baidu.com"',
        siteRequired: '请输入Publisher Site',
        siteFormatError: '请输入至少含一个"."的site',
        mediaGroupPlaceholder: '请输入媒体组名称（非必填，方便备注查询）',
        formNotice: '说明：加白公司、加白账户、加白计划为"或"的关系。选择"加白公司A" → 公司A下的所有账户和计划自动白名单；选择"加白账户B" → 账户B下的所有计划自动白名单；选择"加白计划C" → 仅计划C白名单。三者可同时选择，满足任意条件即生效。',
        companyInputPlaceholder: '请输入公司名称，支持批量输入，以;;区分',
        verifyBtn: '查询验证',
        companyVerifyTip: '请查看公司名是否输入完整、正确。公司名称输入错误的，无法提交成功。',
        pleaseInputCompany: '请输入公司名称',
        someCompanyNotVerified: '以下公司未验证通过：{names}',
        someAccountNotVerified: '以下账户未验证通过：{names}',
        someCampaignNotVerified: '以下计划未验证通过：{names}',
        pleaseInputAccount: '请输入账户ID',
        pleaseInputCampaign: '请输入Campaign ID',
        verifySuccess: '验证成功',
        hasUnverifiedItems: '存在未验证通过的项，请检查后重试',
        submitFailed: '提交失败，请重试',
        blacklistConflict: '请确认添加公司或账户未在本批站点进行过加黑过滤设置',
        validationFailed: '请查看公司名/账户ID/计划ID是否输入完整、正确。输入错误的，无法提交成功',
        blacklistWarning: '请确认添加公司或账户未在本批站点进行过加黑过滤设置',
        notVerified: '(未验证)',
        hasUnverifiedCompany: '存在未验证通过的公司，请检查公司名称是否正确',
        accountInputPlaceholder: '请输入账户ID，支持批量输入，以;;区分',
        accountTip: '请输入账户ID，以;;分隔',
        campaignInputPlaceholder: '请输入Campaign ID，支持批量输入，以;;区分',
        campaignTip: '请输入Campaign ID，以;;分隔',
        atLeastOneRequired: '加白公司、加白账户、加白计划至少填写一项',
        addSuccess: '添加成功',
        updateSuccess: '更新成功',
        dimension: '维度',
        name: '名称',
        addTime: '加白时间',
        company: '公司',
        account: '账户',
        campaign: '计划',
        noMatchFound: '查询不到匹配内容',
        // SSP、流量地区、brandname 相关
        sspId: 'SSP',
        sspPlaceholder: '请选择SSP',
        trafficRegion: '流量地区',
        trafficRegionPlaceholder: '请选择流量地区（选填）',
        mediaDimension: '媒体维度',
        whitelistBrandName: '加白BrandName',
        brandNameInputPlaceholder: '支持批量输入brandname，请以";;"区分.',
        pleaseInputBrandName: '请输入BrandName',
        sectionMediaDimension: '一、媒体维度',
        sectionMaterialLevel: '二、素材层级维度',
        sectionMaterialContent: '三、素材内容维度',
        atLeastOneDimensionNew: '以下维度至少填写一项（公司/账户/计划/brandname）',
        atLeastOneRequiredNew: '加白公司、加白账户、加白计划、加白brandname至少填写一项',
        atLeastOneDimensionRequiredNew: '素材层级维度 与 素材内容维度 至少必填一个维度；若只填素材层级维度，则加白公司、加白账户、加白计划至少填写一项。',
        noticeTitleNew: '请注意：',
        noticePoint1New: '1.素材层级维度 与 素材内容维度 至少必填一个维度， 两个维度为"且"的关系。',
        noticePoint2New: '2.如果只填写"素材层级维度"，不填写"素材内容维度" ，则以下三项内容需要至少填写一项',
        noticeDescLevel: '说明：加白公司、加白账户、加白计划为"或"的关系。',
        noticeDescNew: '说明：加白公司、加白账户、加白计划为"或"的关系；加白brandname与素材层级维度为"且"的关系。',
        noticeItem1New: '选择"加白公司A" → 公司A下的所有账户和计划自动白名单',
        noticeItem2New: '选择"加白账户B" → 账户B下的所有计划自动白名单',
        noticeItem3New: '选择"加白计划C" → 仅计划C白名单',
        noticeItem4New: '三者可同时选择，满足任意条件即生效。',
        noticeItem5New: '加白brandname与以上三个维度为"且"关系，即素材需同时满足层级和内容条件。',
        sspPublisherRule: 'Publisher Site和SSP至少选择一项，且不可同时多选（n×1或1×n）',
        sspPublisherNxNError: 'Publisher Site和SSP不可同时多选',
        tipContent1New: '"加白公司"、"加白账户"、"加白计划"三列是"或"的关系，不是"且"的关系。',
        tipContent2New: '示例：',
        tipContent3New: '• 如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"',
        tipContent4New: '则说明：公司A下的所有账户和计划 + 账户B下的所有计划，都可以上单到该站点。',
        tipContent41New: '而不是：必须同时属于公司A且属于账户B才能上单。',
        tipContent6: '"加白brandname" 与素材层级的 "加白公司"、"加白账户"、"加白计划"维度为"且"的关系。',
        tipContent7: '示例：',
        tipContent8: '• 如果"加白公司"列显示"公司A"，"加白账户"列显示"账户B"，"加白brandname"为"hello"',
        tipContent9: '则说明：公司A下的所有账户和计划 + 账户B下的所有计划，只要素材维度的brandname为"hello"，则这部分素材可以上单到该站点。',
        tipContent5New: '添加site过滤按照精准匹配原则，如有"weather.com"和"www.weather.com"需要匹配，请同时输入"weather.com"和"www.weather.com"。',
        allRegions: '全部地区',
        sspAtLeastOne: 'Publisher Site 与SSP请至少填写一项',
        sspPublisherHint: 'Publisher Site与SSP至少必填一项。同时填写Publisher Site与SSP时，Publisher Site*SSP只支持"n*1"或者"1*n"'
    },
    menuData: {
        publisherSiteTitle: '配置publisher白名单规则',
        dashboardTitle: '控制台',
        editorialTitle: '编辑工具',
        domainTitle: '域名屏蔽',
        authorizeTitle: '权限管理',
        roleTitle: '角色管理',
        accountTitle: '账户管理',
        userTitle: '用户管理',
        managementTitle: '媒体管理',
        audienceTitle: '受众定向配置',
        sensitiveTagTitle: '敏感标签列表',
        sensitiveCfgTitle: '配置敏感标签',
        adxTitle: 'ssp管理',
        discoveryBWconfigTitle: 'D_SSP level 黑白名單',
        siteTitle: '站点管理',
        mediaTagTitle: '标签管理',
        mediaBWconfigTitle: '账户层级媒体黑白名单',
        mediaBWconfig: '账户层级媒体黑白名单',
        mediaSellerIdConfigTitle: '账户层级Seller ID 黑白名单',
        cruiseRejectBlackListTitle: '巡航拒审',
        assetSiteFilter: '素材四元素publisher site流量过滤',
        assetSiteFilterTitle: '素材四元素publisher site流量过滤',
        auditRejectOnceTitle: '单次拒审',
        creativeRiskTitle: '图片素材风控',
        xandrAuditManagment: 'Brand Name送审管理',
        xandrAuditManagmentTitle: 'Brand Name送审管理',
        accountSiteFilter: '账户类型、公司账户屏蔽',
        accountSiteFilterTitle: '账户类型、公司账户屏蔽',
        sspReportTitle: '媒体日报'
    },
    button: {
        addAccount: '添加账户',
        addUser: '添加用户',
        addRole: '添加角色',
        status: '状态',
        del: '删除',
        bwList: '黑白名单'
    },
    sspReport: {
        addDaily: '添加日报',
        addDailyReportTitle: '新增日报配置',
        editDailyReportTitle: '编辑日报配置',
        deleteConfirm: '删除后报告将不会发送，且无法恢复。',
        deleteSuccess: '删除成功',
        updateSuccess: '保存成功',
        loadDetailFailed: '获取配置详情失败',
        emailName: '邮件名称',
        emailNamePh: '请输入邮件名称',
        emailNameMaxLen: '邮件名称不能超过200个字符',
        emailNameNoEmoji: '邮件名称不能包含表情符号',
        emailNameDuplicate: '该邮件名称已存在，请更换',
        dataSource: '数据来源',
        dataSourcePh: '请选择具体的SSP',
        dataSourcePhChannel: '请选择具体的Channel',
        dataSourceTypeSsp: 'SSP',
        dataSourceTypeChannel: 'Channel',
        reportType: '报告类型',
        typeFilterAll: '全部',
        setColumns: '设置列',
        dimSection: '维度',
        metricSection: '指标',
        selectedColumnsTitle: '已选（拖放以重新排序）',
        resetColumns: '重置',
        dimDate: '日期—每月至今分天',
        dimIpCountry: '国家',
        dimIsApp2web: 'Web 或 APP',
        dimTrafficType: '流量类型',
        dimDevice: '设备',
        metricImp: '展示',
        metricImpCost: '流量成本',
        metricCpm: 'CPM',
        metricClicks: 'clicks',
        metricCost: '成本',
        metricImpressions: '展示量',
        columnMetricRequired: '至少选择一个指标',
        recipientRequired: '请填写至少一个收件邮箱',
        recipientPh: '可输入多个邮箱，使用英文逗号分隔',
        sspId: 'SSP ID',
        dimension: '维度',
        metrics: '指标',
        reportTimezone: '报告时区',
        sendTime: '发送时间',
        recipient: '收件人',
        createdAt: '创建时间',
        operate: '操作',
        dimDateShort: '日期',
        timezonePh: '请选择时区',
        sendTimePh: '请选择发送时间',
        createSuccess: '创建成功',
        emailInvalid: '邮箱格式不正确：{email}',
        collapsePanel: '收起'
    },
    dashboard: {
        bwType: '黑白名单类型',
        mediaSearchAcc: '根据账户搜索用户',
        rpm: 'RPM',
        vrpm: 'vRPM',
        matchedRequest: '匹配的广告请求',
        returnAds: '返回广告',
        viewsWithAds: '有广告的观看次数',
        clicks: '广告点击',
        withAds: '% with Ads',
        withVisibility: '% with Visibility',
        vctr: 'vCTR',
        rendersWithAds: '广告渲染',
        winRate: 'Win Rate',
        avgCPC: '平均每次点击费用',
        accountName: '用户名',
        // Dimension
        dimensionDate: '日期',
        dimensionAccount: '帐户',
        dimensionSSP: '媒体平台',
        dimensionSite: '站点',
        payin: '支付'
    },
    editorial: {
        domain: {
            searchPlaceholder: '搜索域名/账户名称',
            remove: '从列表中移除',
            block: '添加屏蔽域名'
        }
    },
    permission: {},
    management: {
        autoAuditTip: '一旦手动重新送审，会同时送审该Brand Name的banner和native流量，请检查两者是否均为拒审，如其中一个流量渠道已通过，建议不要轻易重新送审',
        autoAuditSecondTip: '一旦手动重新送审，会同时送审该Brand Name的banner和native流量，目前该Brand Name的banner/native流量已经过审，请确认是否需要重新送审',
        rejectAutoAudit: '拒审，自动重新送审审核中',
        noLimit: '不限',
        yes: '是',
        no: '否',
        illegalCharacter1: '不支持使用中文分号/中文逗号/英文分号分隔，请使用英文逗号,分隔ssp',
        illegalCharacter2: '不支持使用中文分号/中文逗号/英文分号分隔，请使用英文逗号,分隔campaign id',
        illegalCharacter3: '不支持使用中文分号/中文逗号/英文分号分隔，请使用英文逗号,分隔account id',
        illegalCharacter4: '不支持使用中文分号/中文逗号/英文逗号分隔，请使用英文分号;分隔account id',
        illegalCharacter5: '不支持使用中文分号/中文逗号/英文逗号分隔，请使用英文分号;分隔Seller ID.',
        setWhite: '白名单配置权限',
        meidaWhiteList: 'Campaign维度批量上下单',
        accountConfig: '账户维度批量上下单',
        sspTip1: '为通投SSP，不支持进行上下单操作',
        sspTip2: '为D的SSP，不支持进行上下单操作',
        sspTip3: '参数错误',
        actionDetails: '操作记录',
        detailTip: '详情',
        operate: '操作',
        reAssetIcon: '输入LP点击搜索时，下面重新送审Asset中下拉可显示使用了该Lp的所有未归档Asset。',
        tokenBlockDetail: 'Seller ID Token Block详情',
        tokenBlockDetailTip: '查看Token Block详情',
        reAuditTip: '人工重新送审',
        automaticResubmissionSetTitle: '自动重新送审设置',
        sellerIdText: '该品牌名称已被部分seller ID token block，点击右侧 按钮了解详情',
        brandNameLanguageTip: '该品牌名称因送审语言≠媒体语言，无法获取MSN流量',
        pendingReview: '待送审',
        underReview: '审核中',
        reject: '拒审',
        pass: '通过',
        auditFailure: '送审失败',
        reviewExpired: '审核过期',
        brandNameReviewManagement: 'Brand Name送审管理',
        autoResubmissionSetTitle: '自动重新送审设置',
        autoAuditAccountStatus: '自动重新送审状态',
        isSeller: '送审条件是否包含seller ID 280拒审',
        isLanguageDiff: '送审条件是否包含语言不一致',
        autoAuditAccountNum: '自动重新送审次数',
        assetConditionSettings: '自动重新送审素材条件设置',
        accountRange: '账户范围',
        campaignRange: 'Campaign范围',
        assetRange: 'Asset 条件',
        all: 'All',
        oneDayTop: '按过去一天收入Top',
        anyAll: '随机',
        autoStatusOpt: '开关状态：开启；送审次数：3；账户范围：不限；Campaign范围：不限，Asset条件：按过去一天收入Top',
        autoStatusTip: '默认开启，人工关闭后将会停止自动重新送审',
        isSellerTip: '自动重新送审条件默认为拒审状态，不包含被seller ID 280拒审状态，如果需要包含该状态，请选择"是"',
        isLanguageDiffTip: '自动重新送审条件默认不包含语言不一致状态，如果需要包含该状态，请选择"是"',
        autoResubmissionNumTip: '次数为重新累积制度，如从3次切换到5次，重新计算次数',
        accountAangeTip: '下拉中显示账户为Brand Name对应素材所属账户',
        campaignAangeTip: '下拉中显示Campaign为Brand Name对应素材所属Campaign，如上述账户范围选择了具体账户，则为所选账户下的Campaign',
        assetAangeTip: '默认为按Brand Name所对应Asset过去一天收入Top Asset进行送审，排除已经送审过Asset和已经归档Asset',
        tokenBlock: '已被token block',
        notTokenBlock: '未被token block',
        sellerReason: '原因',
        reAsset: '重新送审Asset',
        xanderBrandName: '品牌名称',
        auditStatus: '审核状态',
        xanderReason: '拒审原因',
        reviewTime: '审核时间',
        submissionTime: '送审时间',
        reviewLang: '送审语言',
        typeSelect: '类型筛选',
        platform: '平台',
        languageUnequal: '送审语言不一致',
        mediaLanguage: '媒体语言',
        type: '送审广告类型',
        asset: '送审素材',
        lp: '当前送审LP',
        xandrAsset: '当前送审素材',
        searchLp: '输入LP搜索Asset',
        addCreativeConfig: '账户下已有creative有相同维度配置，是否选择覆盖配置？',
        creativeTip: '当选择账户维度控制时，可选择汇总控制和平均控制；汇总控制为账户的总和不超过设定的上限值；平均控制为将账户的控制全部作用于其下所有的Creative ID',
        updateCreative: '账户下{num}条creative已有同维度配置，是否需要覆盖其配置? ',
        deleteCreative: '该账户下有{num}条creative已有配置或受其他账户控制，是否需要覆盖删除？',
        controlMethod: '控制方式',
        sourceOfControl: '控制来源',
        summaryControl: '汇总控制',
        decentralizedControl: '下放控制',
        itself: '自身',
        creativePlaceholder: '请输入Creative ID，并且使用,分隔',
        companyLevel: '公司层级',
        accountLevel: '账户层级',
        deleteDimension: '删除后，针对该维度的条件限制将失效，是否确认删除？',
        companyName: '公司名称',
        accountName: '账户名称',
        accountId: '账户ID',
        campaginId: '广告计划',
        campaginSearch: '广告计划 ID',
        dimension: '维度',
        audienceAdd: '添加受众定向',
        sensitiveTagAdd: '添加敏感标签',
        sensitiveCfgAdd: '添加敏感标签配置',
        // adx
        rejectedSources: '拒审来源',
        modifyAdx: '修改adx',
        addWhiteList: '批量操作白名单',
        setWhiteForD: 'Discovery DSP 媒体白名单配置',
        setDisplaySsp: 'Display SSP自动上单配置',
        addAdx: '新增ssp',
        adxSspId: 'sspid',
        adxSspName: 'ssp名称',
        adxToken: 'token',
        adxHMedia: '是否为高级媒体',
        adxIp: '是否使用客户端ip',
        adxGEOEdge: 'GEO Edge',
        adxAddSuccess: '新建成功',
        adxModifySuccess: '修改成功',
        timezone: '时区',
        ssp: 'ssp',
        operateType: '操作类型',
        campaginName: '广告计划名称',
        reason: '理由',
        creativeIdMsg: '删除后，将不再执行新的拒审，已经被拒审的asset仍保留“拒审“状态。',
        rejectMsg: '终止后，将不再执行新的拒审，已经被拒审的asset仍保留“拒审“状态。',
        searchSpend: '查询花费',
        mediaRequire: '媒体要求',
        required: '{name} 不能为空',
        dailyCost: '单日消耗上限',
        dailyImp: '单日展示上限',
        addNewConfig: '新增设置',
        assetImageMsg: '删除后，针对该Creative ID的条件限制将失效，是否确认删除？',
        dailyCostTip: '单日消耗为EST时区所设置条件下所选维度消耗总和，当触达单日消耗或展示任意上限，则对应流量不可召回。',
        dailyImpTip: '单日消耗为EST时区所设置条件下所选维度消耗总和，当触达单日消耗或展示任意上限，则对应流量不可召回。',
        countryTip: '多选地区时，其会拆分进行统计，其与维度中选择为N*N关系。例如，地区选择美国，英国，维度中选择了账户1，则提交后页面会出现2条数据，账户1在美国，账户1在英国的控制。',
        hasCreativeId: '该Creative ID已存在，请从操作列中编辑笔入口进行操作',
        hasSppGroup: '该SSP组合已存在，请在原有组合中编辑',
        sitePlaceHolder: '支持批量添加媒体站点，请使用,分隔',
        dailyCostValid: '单日消耗只能保留2位小数点',
        element: '元素',
        country: '国家',
        language: '语言',
        content: '内容',
        rejectedReason: '拒审原因',
        brandName: '品牌名称',
        keyword: '标题',
        domainName: '落地页域名',
        operator: '操作人',
        reviewer: '审核员',
        rejectAddSuccess: '添加成功',
        createTime: '创建时间',
        completionTime: '完成时间',
        operatingTime: '操作时间',
        status: '状态',
        doing: '执行中，点击可终止',
        stop: '已终止',
        done: '已完成',
        download: '下载',
        detail: '查看',
        success: '成功',
        downloadToReject: '请下载详细内容以便二次确认拒审',
        noDownload: '请先下载详细内容再确认拒审',
        isConfrimReject: '是否确认拒审？',
        contentTitle: `【Creative ID 维度内容举例】
        素材图片url：https://resource.popin.cc/ML/c5d69c5de0bbac6490bda9d103btestd.png
        输入内容：c5d69c5de0bbac6490bda9d103btestd
        （https://resource.popin.cc/ML/和.png之间的部分）
        【品牌名称维度内容举例】
        品牌名称：Test Brand
        输入内容：Test Brand
        【标题维度内容举例】
        素材标题：Be careful if you have these illegal words around you!
        「情况1」输入内容：illegal words
        匹配：Be careful if you have these illegal words around you!;;These illegal words will affect your life
        「情况2」输入内容：Be careful if you have these illegal words around you!
        匹配：Be careful if you have these illegal words around you!
        【落地页域名维度内容举例】
        落地页域名：https://test.cloudfront.net/
        输入内容：test.cloudfront.net
        （https:// 和 /之间的部分）`,
        rejectTitle: '* 2023年4月17日前的操作记录均展示为百度拒审。'
    },
    rejectCountry: {
        CA:	'加拿大',
        JP:	'日本',
        US: '美国',
        CH:	'瑞士',
        PT:	'葡萄牙',
        BE:	'比利时',
        MX:	'墨西哥',
        BR:	'巴西',
        HU:	'匈牙利',
        DK:	'丹麦',
        NO:	'挪威',
        CZ:	'捷克',
        SE:	'瑞典',
        PL:	'波兰',
        NL:	'荷兰',
        ES:	'西班牙',
        AT: '奥地利',
        IT:	'意大利',
        GB:	'英国',
        AU: '澳大利亚',
        KR: '韩国',
        TW:	'台湾',
        ID:	'印度尼西亚',
        SG:	'新加坡',
        MY: '马来西亚',
        TH:	'泰国',
        HK:	'香港',
        DE:	'德国',
        FR:	'法国'
    },
    rejectLanguage: {
        en: '英语',
        de: '德语',
        pt: '葡萄牙语',
        fr: '法语',
        es: '西班牙语',
        hu: '匈牙利语',
        da: '丹麦语',
        nb: '挪威语',
        cs: '捷克语',
        sv: '瑞典语',
        pl: '波兰语',
        nl: '荷兰语',
        it: '意大利语'
    },
    rejectReason: {
        celebrity: '因不合规名人标题而被拒绝',
        Cryptocurrency: '由于不合规的加密货币标题而被拒绝',
        suffering: '由于不合规的痛苦/暴力标题而被拒绝',
        sensitive: '因不合规敏感标题而被拒绝'
    },
    siteList: {
        listRuleTip:
            '当前列表仅展示已配置过广告审核 / 机器脚本标签的站点，未配置标签的站点请点击右上角【新增站点】按钮进行配置',
        deleteConfirmText: '删除后该站点的广告审核标签和机器脚本标签全量解绑。<br/>删除操作不可取消，请点击确认按钮以继续。',
        deleteSuccess: '删除成功',
        logDialogTitle: '操作日志'
    },
    siteTagDialog: {
        titleAdd: '新增站点',
        titleEdit: '编辑站点',
        product: '平台',
        productMediaGo: 'MediaGo',
        publisherSite: 'publisher site',
        publisherSiteTip:
            '仅可选择MediaGo下未配置过任何广告审核/机器脚本标签的站点,配置完成后站点将自动纳入站点列表',
        selectSitePlaceholder: '选择publisher site,支持精准匹配',
        maxSitesTip: '最多支持一次性选择50个站点',
        auditTags: '广告审核标签',
        scriptTags: '机器脚本标签',
        scriptTagsDevTip:
            '【开发使用】非产品/研发人员请勿操作,错配将导致线上审核规则异常',
        scriptCollapseAddTitle: '机器脚本标签（点击展开）',
        scriptExpandLink: '点击展开机器脚本标签',
        scriptCollapseLink: '点击收起机器脚本标签',
        auditGroupOther: '其他',
        msgSelectSite: 'publisher site为必填字段',
        msgAuditRequired: '广告审核标签为必填字段',
        msgSaveSuccess: '保存成功',
        msgSaveFail: '保存失败',
        msgConflict: '保存失败!数据已更新,请刷新页面重试',
        msgMaxSites: '最多支持一次性选择{n}个站点'
    },
    creativeRisk: {
        constantSpeedControl: '账户层级（匀速控制）',
        constantSpeedControlTip: '请注意：账户层级和账户层级（匀速控制）会同时生效。在极端情况下，可能会先达到账户层级的单日消耗上限，导致用户强烈感知。建议配置完毕后检查账户层级列表，如果匀速控制账户存在账户层级配置，建议删除账户层级配置，以避免极端情况。',
        dailyCostTip: '单日消耗为EST时区所设置条件下所选维度消耗总和，当触达单日消耗上限，则账户下Campaign不可召回。限额将按照账户下Campaign天预算进行比例分配限制额度达到均匀控制效果，具体公式：每个开启的Campaign分到的限额=单日消耗上限*（Campaign天预算/全部开启的天预算之和）',
        addBtn: '新增匀速控制',
        dailyCostCannotBeZero: '单日消耗上限不能为0',
        dailyCostMustBeNumber: '单日消耗上限必须为数字',
        accountSpeedControlTipText: '请注意：账户层级（匀速控制）的所有新增、删除和编辑操作需要等待最多一个小时才会生效，不会立即生效。'
    }
};
